import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import BackButton from "../../GoBack/GoBack";
import { useParams } from "react-router-dom";
import { useAuthStudent } from "../../../../context/StudentLoginContext/StudentAuthContext";
import { StudentMapMenu } from "../../Map/MapMenu/MapMenu";
import JwPlayerMultiLanguage from "../Players/EpisodesDetailPlayer/JwPlayerMultiLanguage";

const StudentAdminFestival = () => {
  const { questId, chapterId } = useParams();
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiImgurl = process.env.REACT_APP_IMG_URL;
  const { student ,fetchWithAuthStudent} = useAuthStudent();
  const [chapters, setChapters] = useState(null);
  const [loadingvideo, setLoadingVideo] = useState(true);

  useEffect(() => {
    const fetchChapterData = async () => {
      if (!student || !student.token) {
        return;
      }

      try {
        const response = await fetchWithAuthStudent(
          `${apiUrl}/student/quest-chapter/${chapterId}`,
          {
            method: "GET",
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch chapters");
        }

        const data = await response.json();

          setChapters(data);
          setLoadingVideo(false);
      } catch (error) {
        setLoadingVideo(false);
      }
    };

    fetchChapterData();
  }, [apiUrl, student, questId, chapterId,fetchWithAuthStudent]);

  const videoSources = React.useMemo(() => {
    if (!chapters?.chapter) return null; // Prevent null error

    return {
      en:
        chapters.chapter.videoType === "jwplayer"
          ? `https://cdn.jwplayer.com/manifests/${chapters.chapter.jwpIdEnglish}.m3u8`
          : `${apiImgurl}/code/public/storage/${chapters.chapter.videoEng}`,
      hi:
        chapters.chapter.videoType === "jwplayer"
          ? `https://cdn.jwplayer.com/manifests/${chapters.chapter.jwpIdHindi}.m3u8`
          : `${apiImgurl}/code/public/storage/${chapters.chapter.videoHin}`,
    };
  }, [chapters, apiImgurl]);

  return (
    <div className="StudentAdminBody StudentBodyMrgn">
      <div className="container-fluid">       

        <div className="teacher-bodycontent mb-4">
          <section>
            <div className="row mb-4">
              <div className="col-md-12">
                <BackButton />
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-lg-7 col-md-12 mb-4 mb-lg-0">
                    {loadingvideo ? (
                      <Skeleton height={250} width="100%" />
                    ) : (
                      <div className="EpisodeTrailerVideo" style={{
                        paddingBottom: "20px", // Space for footer height
                        position: "relative",
                        zIndex: 1, // Make sure it's not hidden
                      }}>
                        <JwPlayerMultiLanguage
                          questId={questId}
                          videoSources={videoSources}
                          nextEpisodeId={chapters?.next_chapter}
                          videoStartTime={
                            Number(
                              chapters?.remaining_time?.videoTimeStamp
                            ) || Number(0)
                          }
                            chapters={chapters}
                            type={"festive"}
                        />
                      </div>
                    )}
                  </div>
                  <div className="col-lg-5 col-md-12">
                    <div className="EpisodeTrailerCard">
                      <p className="EpisodeTrailerVideo-Titl mb-2">
                        {loadingvideo ? (
                          <Skeleton width={150} />
                        ) : (
                          chapters?.chapter?.title
                        )}
                      </p>

                      <p className="EpisodeTrailerVideo-Para">
                        {loadingvideo ? (
                          <Skeleton count={3} />
                        ) : (
                          chapters?.chapter?.description
                        )}
                      </p>
                      {/* {!loadingvideo && chapters?.length > 0 && (
                        <p className="mb-0 mt-5">
                          <Link
                            to={`/student/admin/episodes/detail/${questId}/${chapters?.[0]?.id}`}
                            className="EpisodeTrailerVideo-Btn"
                          >
                            Start Now
                          </Link>
                        </p>
                      )} */}
                    </div>
                  </div>
                </div>
              </div>
              {/* {showSubscriptionModal && (
                <SubscriptionModal
                  handleClose={() => setShowSubscriptionModal(false)}
                  showSubscriptionModal={showSubscriptionModal}
                  navigateUrl={`/student/admin/quests`}
                />
              )} */}
            </div>
          </section>
          <div style={{}}>
            {/* Left Image */}
            <img
              src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/LeftSideDesign.png"
              alt="left"
              className="position-fixed"
              style={{
                left: 0,
                top: "10vh",
                height: "90vh",
                bottom: "auto",
                width: "auto",
                zIndex: -1, // Keeps it in the background
              }}
            />

            {/* Right Image */}
            <img
              src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/RightSideDesign.png"
              alt="right"
              className="position-fixed"
              style={{
                right: 0,
                top: "20vh",
                height: "70vh",
                width: "auto",
                zIndex: -1, // Keeps it in the background
              }}
            />

            {/* Page Content */}
          </div>
          {/* <StudentFooter /> */}
          <StudentMapMenu />
        </div>
      </div>
    </div>
  );
};

export default StudentAdminFestival;
